import { Controller } from "@hotwired/stimulus";
import IMask from "imask";


export default class extends Controller {
  static values = {
    mask: String,
    min: Number,
    max: Number,

  }

  connect() {
    this.applyMask()
  }

  applyMask(){
    switch (this.maskValue) {
      case "salary":
        this.salaryMask()
        break;
      case "integer":
        this.integerMask()
        break;
      default:
        break;
    }
  }

  integerMask() {
    IMask(this.element, {
      mask: Number,
      scale: 0,
      signed: false,
      thousandsSeparator: '',
      min: this.hasMinValue ? this.minValue : 0,
      max: this.hasMaxValue ? this.maxValue : Number.MAX_SAFE_INTEGER
    })
  }

  salaryMask() {
    IMask(this.element, {
      mask: Number,
      scale: 0,
      signed: false,  // disallow negative
      thousandsSeparator: '.',
      min: this.hasMinValue ? this.minValue : 0,
      max: this.hasMaxValue ? this.maxValue : 3000000
    })
  }
}
